import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    kpiId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.kpiAudit.getAuditLogs, {
        kpiId,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
